import {
  GET_COMBO_CHDT,
  GET_COMBO_CHDT_SUCCESS,
  GET_COMBO_CHDT_FAILURE,
} from 'actions/CuaHangDoiTac/actionTypes';

const initialState = {
  getComboCHDTLoading: false,
  combo: [],
};

const getComboCHDT = (state, action) => ({
  ...state,
  getComboCHDTLoading: true,
});

const getComboCHDTSuccess = (state, action) => {
  return {
    ...state,
    getComboCHDTLoading: false,
    combo: action.payload,
  };
};

const getComboCHDTFailed = (state, action) => ({
  ...state,
  getComboCHDTLoading: false,
  combo: [],
});

const cuaHangDoiTacReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_COMBO_CHDT:
      return getComboCHDT(state, action);
    case GET_COMBO_CHDT_SUCCESS:
      return getComboCHDTSuccess(state, action);
    case GET_COMBO_CHDT_FAILURE:
      return getComboCHDTFailed(state, action);
    default:
      return state;
  }
};

export default cuaHangDoiTacReducer;
